// Machine-assisted concept-only labels for Somali, Gujarati, Farsi and Chinese.
// Require professional linguistic QA and clinical review before patient distribution.
export const ADDITIONAL_OTHER_PRINT_LABELS = Object.freeze({
  "so": {
    "whatMayHappen": "Waxa dhici kara",
    "whyItMayHappen": "Sababta ay tani u dhici karto",
    "whatTeamIsDoing": "Waxa kooxdaada daryeelku samaynayso",
    "variationNote": "Tani way kala duwanaan kartaa",
    "nextSteps": "Waxa xiga ee dhici kara",
    "professionalClothes": "Badanaa wuxuu xirtaa dhar shaqo oo xirfadeed halkii uu ka xiran lahaa darees caadi ah.",
    "wearsColourGarment": "Badanaa wuxuu xirtaa {garment} midabkiisu yahay {colour}.",
    "wearsGarment": "Badanaa wuxuu xirtaa {garment}.",
    "genericGarment": "dhar caafimaad",
    "preparationChecklist": "Liiska hubinta diyaar-garowga",
    "understandingReminder": "Raac tilmaamaha kooxda isbitaalkaaga. Haddii wax aanay kuu caddayn, weydii kooxda daryeelka.",
    "whatYouMightHear": "Waxyaabaha aad maqli karto",
    "whatItMeans": "Waxay ka dhigan tahay:",
    "questionsToConsider": "Su'aalaha aad jeclaan karto inaad weydiiso",
    "peopleYouMayMeet": "Dadka aad la kulmi karto",
    "clothes": "Dhar:",
    "officialHospitalInformation": "Macluumaadka waxtarka leh ee isbitaalka",
    "localHospital": "Isbitaalka deegaanka",
    "forLocalReview": "Dib-u-eegista isbitaalka deegaanka",
    "evaluationDraft": "Qabyo loogu talagalay qiimayn",
    "prepared": "La diyaariyey",
    "coverReminder": "Hagahan waxaa loogu talagalay macluumaad iyo diyaar-garow. Mar walba raac talada kooxda isbitaalkaaga.",
    "stage": "Marxalad",
    "of": "ka mid ah",
    "yourCareTeam": "Kooxdaada daryeelka",
    "questionsAndNotes": "Su'aalo iyo qoraallo",
    "questionsToAskMyTeam": "Su'aalo aan weydiinayo kooxdayda",
    "writingPrompt": "Halkan ku qor wixii aad rabto inaad weydiiso kooxda isbitaalkaaga.",
    "spaceForQuestions": "Meel su'aalaha lagu qoro",
    "notesToRemember": "Qoraallo la xusuusto",
    "notesPrompt": "Meeshan u isticmaal taariikho, tilmaamo ama qoraallo kale.",
    "spaceForNotes": "Meel qoraallo lagu qoro",
    "importantInformation": "Macluumaad muhiim ah",
    "pleaseRemember": "Fadlan xusuusnow",
    "askForExplanation": "Haddii wax aanay kuu caddayn, weydii kooxda isbitaalkaaga inay kuu sharxaan.",
    "footerAdvice": "Talada ka xaqiiji kooxda isbitaalkaaga."
  },
  "gu": {
    "whatMayHappen": "શું થઈ શકે છે",
    "whyItMayHappen": "આવું શા માટે થઈ શકે છે",
    "whatTeamIsDoing": "તમારી સંભાળ ટીમ શું કરી રહી છે",
    "variationNote": "આ બાબત બદલાઈ શકે છે",
    "nextSteps": "આગળ શું થઈ શકે છે",
    "professionalClothes": "સામાન્ય રીતે નિશ્ચિત યુનિફોર્મના બદલે વ્યાવસાયિક કપડાં પહેરે છે.",
    "wearsColourGarment": "સામાન્ય રીતે {colour} રંગનાં {garment} પહેરે છે.",
    "wearsGarment": "સામાન્ય રીતે {garment} પહેરે છે.",
    "genericGarment": "આરોગ્યસંભાળનાં કપડાં",
    "preparationChecklist": "તૈયારીની તપાસ યાદી",
    "understandingReminder": "તમારી હોસ્પિટલની ટીમની સૂચનાઓનું પાલન કરો. કંઈ સ્પષ્ટ ન હોય તો સંભાળ ટીમને પૂછો.",
    "whatYouMightHear": "તમે શું સાંભળી શકો છો",
    "whatItMeans": "તેનો અર્થ:",
    "questionsToConsider": "તમે પૂછી શકો એવા પ્રશ્નો",
    "peopleYouMayMeet": "તમે જેમને મળી શકો છો",
    "clothes": "કપડાં:",
    "officialHospitalInformation": "હોસ્પિટલની ઉપયોગી માહિતી",
    "localHospital": "સ્થાનિક હોસ્પિટલ",
    "forLocalReview": "હોસ્પિટલની સમીક્ષા માટે",
    "evaluationDraft": "મૂલ્યાંકન માટેનો મુસદ્દો",
    "prepared": "તૈયાર કર્યાની તારીખ",
    "coverReminder": "આ માર્ગદર્શિકા માહિતી અને તૈયારી માટે છે. હંમેશાં તમારી પોતાની હોસ્પિટલ ટીમની સલાહ અનુસરો.",
    "stage": "તબક્કો",
    "of": "માંથી",
    "yourCareTeam": "તમારી સંભાળ ટીમ",
    "questionsAndNotes": "પ્રશ્નો અને નોંધો",
    "questionsToAskMyTeam": "મારી ટીમને પૂછવાના પ્રશ્નો",
    "writingPrompt": "તમારી હોસ્પિટલની ટીમને જે કંઈ પૂછવું હોય તે અહીં લખો.",
    "spaceForQuestions": "પ્રશ્નો લખવાની જગ્યા",
    "notesToRemember": "યાદ રાખવાની નોંધો",
    "notesPrompt": "તારીખો, સૂચનાઓ અથવા અન્ય નોંધો માટે આ જગ્યા વાપરો.",
    "spaceForNotes": "નોંધો લખવાની જગ્યા",
    "importantInformation": "મહત્ત્વપૂર્ણ માહિતી",
    "pleaseRemember": "કૃપા કરીને યાદ રાખો",
    "askForExplanation": "કંઈ સ્પષ્ટ ન હોય તો તમારી હોસ્પિટલની ટીમને સમજાવવા કહો.",
    "footerAdvice": "તમારી હોસ્પિટલની ટીમ પાસે સલાહની ખાતરી કરો."
  },
  "fa": {
    "whatMayHappen": "چه اتفاقی ممکن است بیفتد",
    "whyItMayHappen": "چرا ممکن است این اتفاق بیفتد",
    "whatTeamIsDoing": "تیم مراقبت شما چه کاری انجام می‌دهد",
    "variationNote": "این موضوع ممکن است متفاوت باشد",
    "nextSteps": "در ادامه چه اتفاقی ممکن است بیفتد",
    "professionalClothes": "معمولاً به‌جای لباس فرم استاندارد، لباس حرفه‌ای می‌پوشد.",
    "wearsColourGarment": "معمولاً {garment} به رنگ {colour} می‌پوشد.",
    "wearsGarment": "معمولاً {garment} می‌پوشد.",
    "genericGarment": "پوشاک درمانی",
    "preparationChecklist": "فهرست بررسی آمادگی",
    "understandingReminder": "دستورالعمل‌های تیم بیمارستان خود را دنبال کنید. اگر موضوعی روشن نیست، از تیم مراقبت خود بپرسید.",
    "whatYouMightHear": "چه چیزهایی ممکن است بشنوید",
    "whatItMeans": "معنی آن:",
    "questionsToConsider": "پرسش‌هایی که شاید بخواهید بپرسید",
    "peopleYouMayMeet": "افرادی که ممکن است ملاقات کنید",
    "clothes": "لباس:",
    "officialHospitalInformation": "اطلاعات مفید بیمارستان",
    "localHospital": "بیمارستان محلی",
    "forLocalReview": "برای بررسی توسط بیمارستان",
    "evaluationDraft": "پیش‌نویس ارزیابی",
    "prepared": "تهیه‌شده در",
    "coverReminder": "این راهنما برای اطلاع‌رسانی و آمادگی است. همیشه توصیه‌های تیم بیمارستان خود را دنبال کنید.",
    "stage": "مرحله",
    "of": "از",
    "yourCareTeam": "تیم مراقبت شما",
    "questionsAndNotes": "پرسش‌ها و یادداشت‌ها",
    "questionsToAskMyTeam": "پرسش‌هایی از تیم خودم",
    "writingPrompt": "هر سؤالی را که می‌خواهید از تیم بیمارستان بپرسید اینجا یادداشت کنید.",
    "spaceForQuestions": "فضایی برای نوشتن پرسش‌ها",
    "notesToRemember": "یادداشت‌هایی برای یادآوری",
    "notesPrompt": "از این فضا برای ثبت تاریخ‌ها، دستورالعمل‌ها یا یادداشت‌های دیگر استفاده کنید.",
    "spaceForNotes": "فضایی برای یادداشت‌ها",
    "importantInformation": "اطلاعات مهم",
    "pleaseRemember": "لطفاً به یاد داشته باشید",
    "askForExplanation": "اگر موضوعی روشن نیست، از تیم بیمارستان بخواهید آن را توضیح دهد.",
    "footerAdvice": "توصیه‌ها را با تیم بیمارستان خود بررسی کنید."
  },
  "zh": {
    "whatMayHappen": "可能会发生什么",
    "whyItMayHappen": "为什么可能会发生这种情况",
    "whatTeamIsDoing": "您的医疗团队正在做什么",
    "variationNote": "具体情况可能有所不同",
    "nextSteps": "接下来可能会发生什么",
    "professionalClothes": "通常穿着职业服装，而不是统一的制服。",
    "wearsColourGarment": "通常穿着{colour}色的{garment}。",
    "wearsGarment": "通常穿着{garment}。",
    "genericGarment": "医护工作服",
    "preparationChecklist": "准备事项核对清单",
    "understandingReminder": "请遵循您所在医院医疗团队的指示。如有不清楚的地方，请咨询医疗团队。",
    "whatYouMightHear": "您可能听到的话",
    "whatItMeans": "这是什么意思：",
    "questionsToConsider": "您可能想问的问题",
    "peopleYouMayMeet": "您可能遇到的人员",
    "clothes": "服装：",
    "officialHospitalInformation": "医院提供的实用信息",
    "localHospital": "当地医院",
    "forLocalReview": "供医院审核",
    "evaluationDraft": "评估草稿",
    "prepared": "编制日期",
    "coverReminder": "本指南旨在提供信息并帮助您做好准备。请始终遵循您所在医院医疗团队的建议。",
    "stage": "阶段",
    "of": "共",
    "yourCareTeam": "您的医疗团队",
    "questionsAndNotes": "问题和笔记",
    "questionsToAskMyTeam": "我想向医疗团队提出的问题",
    "writingPrompt": "请在此写下您想向医院医疗团队提出的问题。",
    "spaceForQuestions": "填写问题的空白处",
    "notesToRemember": "需要记住的事项",
    "notesPrompt": "请在此记录日期、指示或其他笔记。",
    "spaceForNotes": "填写笔记的空白处",
    "importantInformation": "重要信息",
    "pleaseRemember": "请注意",
    "askForExplanation": "如果有不清楚的地方，请让医院医疗团队为您解释。",
    "footerAdvice": "请向您所在医院的医疗团队核实相关建议。"
  }
});
